/* Mounts the custom hero into the theme's product info column and keeps it in
   sync with the theme's own variant radios, so Dawn still drives price,
   gallery and availability. A second block (trust row + mini FAQ) lands under
   the CTA. */
window.lvPhMount = function (id, atcLabel, afterId) {
  var root = document.getElementById(id);
  var after = afterId ? document.getElementById(afterId) : null;
  if (!root || root.dataset.lvMounted) return;

  function radios() {
    return [].slice.call(document.querySelectorAll(
      'variant-selects input[type="radio"], .product-form__input input[type="radio"]'));
  }

  function hideThemeBits() {
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (e) {
      e.classList.add('lv-ph-clip');
    });
  }

  function labelCta() {
    if (!atcLabel) return;
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;
    var span = btn.querySelector('span:not(.loading__spinner):not(.loading-overlay__spinner)');
    if (span && span.textContent.trim() !== atcLabel) span.textContent = atcLabel;
  }

  function place() {
    var form = document.querySelector('product-form');
    var anchor = form || document.querySelector('.product-form__buttons');
    if (!anchor || !anchor.parentElement) return false;
    anchor.parentElement.insertBefore(root, anchor);
    if (after) {
      anchor.parentElement.insertBefore(after, anchor.nextSibling);
      after.hidden = false;
    }
    root.hidden = false;
    root.dataset.lvMounted = '1';
    hideThemeBits();
    labelCta();
    return true;
  }

  function cards() {
    return [].slice.call(root.querySelectorAll('.lv-ph__variant'));
  }

  function paint(value) {
    cards().forEach(function (c) {
      c.classList.toggle('is-selected', c.dataset.value === value);
    });
  }

  function currentValue() {
    var r = radios().filter(function (x) { return x.checked; })[0];
    return r ? r.value : null;
  }

  /* What the buy button would actually add. This is the only honest check that
     a selection took: ticking the radio is not enough, because the theme only
     rewrites the form once its own component has picked the change up. */
  function formVariantId() {
    var i = document.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return i ? String(i.value) : null;
  }

  function select(value, force) {
    var hit = radios().filter(function (x) { return x.value === value; })[0];
    if (!hit) return;
    if (!hit.checked || force) {
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
    }
    paint(value);
  }

  /* The page can offer fewer versions than the product has variants - a shop
     that sells one kit shows one card. The theme still defaults to its first
     variant, which may have no card here, and then nothing looks chosen while
     the buy button quietly adds that other variant at its own price.

     So the selection is moved onto a version the page actually sells. The first
     nudge can land before the theme's variant component has upgraded, in which
     case the radio ticks but the form keeps the old id - hence the re-dispatch
     until the form agrees, rather than a single fire and hope. A ?variant= link
     to a version that IS on the page is left alone. */
  function syncToCards() {
    var cs = cards();
    if (!cs.length) return;
    var cur = currentValue();
    var onPage = cs.filter(function (c) { return c.dataset.value === cur; })[0];
    if (onPage) { paint(cur); return; }

    var target = cs[0];
    var want = target.dataset.variantId;
    var n = 0;
    (function push() {
      select(target.dataset.value, n > 0);
      if (!want || formVariantId() === want) return;
      if (n++ < 25) setTimeout(push, 200);
    })();
  }

  root.addEventListener('click', function (e) {
    var card = e.target.closest('.lv-ph__variant');
    if (card) select(card.dataset.value);
  });
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest('.lv-ph__variant');
    if (card) { e.preventDefault(); select(card.dataset.value); }
  });

  // the theme re-renders the buy block on every variant change, which wipes the
  // CTA label, so re-apply it after each one
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio' && e.target.closest('.product-form__input')) {
      paint(e.target.value);
      setTimeout(labelCta, 60);
      setTimeout(labelCta, 400);
    }
  });

  // bundle toggle: adds the companion variant alongside the wand, when one is set
  if (after) {
    var box = after.querySelector('[data-lv-bundle-variant]');
    if (box) {
      var addVariant = box.getAttribute('data-lv-bundle-variant');
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
        if (!box.checked || !addVariant) return;
        e.preventDefault();
        var fd = new FormData(f);
        var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) },
                     { id: Number(addVariant), quantity: 1 }];
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () { window.location = '/cart'; });
      }, true);
    }
  }

  var tries = 0;
  (function waitForForm() {
    if (place()) { syncToCards(); return; }
    if (tries++ < 40) setTimeout(waitForForm, 150);
  })();
};
